import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import MenuPage from "@/pages/MenuPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MenuPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0f172a",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fdfbf7",
          },
        }}
      />
    </div>
  );
}

export default App;
